<template>
  <div>
    <div class="soft-products__keyVisual">
      <div class="soft-products__keyTitleArea">
        <div class="soft-products__keyTitleLogo">
          <a href="/awuxa/"
            ><img
              src="../../assets/img/logo.svg"
              alt="附帶導航！一做就上手 第一次的遊戲程式設計 "
          /></a>
        </div>
        <div class="soft-products__keyTitle">
          <div class="soft-products__keyTitleJp">
            <p>商品信息</p>
          </div>
          <div class="soft-products__keyTitleEn">
            <p>PRODUCTS INFORMATION</p>
          </div>
        </div>
      </div>
      <div class="soft-products__keyLogo">
        <a href="/software"
          ><img
            src="../../assets/img/ncommon/_common/logo/switch.svg"
            alt="NINTENDO SWITCH"
        /></a>
      </div>
    </div>
    <!-- outer -->
    <div class="soft-products__outer">
      <!-- page start -->
      <div id="soft-products__page" class="scroll-start">
        <div
          id="soft-products__stickyNav"
          data-njs="sticky"
          class="soft-products__sticky scroll-target"
          :class="scrollClass"
        >
          <div class="soft-products__stickyInner" data-njs="sticky__inner">
            <div class="soft-products">
              <div class="soft-products__inner">
                <div class="soft-products__listsWrap">
                  <ul class="soft-products__list">
                    <li
                      class="soft-products__item"
                      :class="{ 'js-active': activeSection === '#section01' }"
                    >
                      <a
                        data-njs="smoothscroll"
                        data-target="#section01"
                        href="javascript:void(0);"
                        @click="toSection('#section01')"
                        >软件信息</a
                      >
                    </li>
                    <li
                      class="soft-products__item"
                      :class="{ 'js-active': activeSection === '#section02' }"
                    >
                      <a
                        data-njs="smoothscroll"
                        data-target="#section02"
                        href="javascript:void(0);"
                        @click="toSection('#section02')"
                        >软件使用人数・手柄</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ncommon-l-content">
          <div id="section01" class="soft-products__section">
            <div class="soft-products__sectionInner">
              <div class="soft-products__soft soft-products__soft--soft">
                <div
                  class="soft-products__softImageTextUnit soft-products__softImage--sp"
                >
                  <div
                    v-if="isMobile"
                    data-njs="toggleparent"
                    data-parent_sp=".soft-products__softImage--sp"
                    data-inited-toggleparent="1"
                    class="js-moduleready"
                  >
                    <div class="soft-products__softImageTitle">
                      <span class="soft-products__softImageTitle--sub"
                        >Nintendo Switch 软件</span
                      >附带导航！一做就上手<br />第一次的游戏程序设计
                    </div>
                  </div>
                </div>
                <div class="soft-products__softImage">
                  <div class="soft-products__softImageInner">
                    <div
                      class="soft-products__softImageThumb thumbPic"
                      data-njs="image"
                      data-tab="../../assets/img-soft__thumb--pc.jpg"
                      data-sp="../../assets/img-soft__thumb--pc.jpg"
                    ></div>
                    <div class="soft-products__softImageFoot">
                      <div class="soft-products__softImageLabel">下载版</div>
                    </div>
                  </div>
                </div>
                <div class="soft-products__softContent">
                  <div
                    class="soft-products__softImageTextUnit soft-products__softImage--pc"
                  >
                    <div
                      v-if="!isMobile"
                      data-njs="toggleparent"
                      data-parent_sp=".soft-products__softImage--sp"
                    >
                      <div class="soft-products__softImageTitle">
                        <span class="soft-products__softImageTitle--sub"
                          >Nintendo Switch 软件</span
                        >附带导航！一做就上手<br />第一次的游戏程序设计
                      </div>
                    </div>
                  </div>

                  <div
                    class="soft-products__softDl soft-products__box soft-products__box--white"
                  >
                    <div
                      class="soft-products__boxInner soft-products--leftBorder"
                    >
                      <div class="soft-products__sheadline">
                        <p class="soft-products__sheadlineTitle">下载版</p>
                        <div class="soft-products__sheadlineInfo">
                          <p class="soft-products__text">
                            发售日：<span class="soft-products__number"
                              >2022.10.31</span
                            >
                          </p>
                          <p class="soft-products__text">
                            价格：<span class="soft-products__number"
                              >149元</span
                            >
                          </p>
                        </div>
                      </div>
                      <div class="soft-products__softDownloads">
                        <!-- S 立即购买 -->
                        <div
                          class="button-buy-wrap button-buy--qrcode button-buy--suit buy-now buy-go"
                        >
                          <div class="game-box-btn game-buy-btn">
                            <div class="nt-button nt-button--default">
                              <a href="javascript:" target="_self">
                                <i class="button-icon--buy">
                                  <svg
                                    viewBox="0 0 58 46"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M0 2H13.3751L19.5276 34.9948H55.9078"
                                      stroke="white"
                                      stroke-width="4"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M14.6646 5.6665H53.0502C55.5114 5.6665 57.3888 7.86813 57 10.2985L54.6139 25.2115C54.3034 27.152 52.6293 28.5795 50.6641 28.5795H19.2472L14.6646 5.6665Z"
                                      fill="white"
                                    />
                                    <circle
                                      cx="27.4952"
                                      cy="40.9376"
                                      r="4.58261"
                                      fill="white"
                                    />
                                    <circle
                                      cx="45.8263"
                                      cy="40.9376"
                                      r="4.58261"
                                      fill="white"
                                    />
                                  </svg>
                                </i>
                                前往购买
                                <i class="button-icon">
                                  <svg
                                    id="right-stroke-arrow"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="60"
                                    height="60"
                                    viewBox="0 0 60 60"
                                    aria-labelledby="right-stroke-arrow"
                                    role="presentation"
                                    fill="currentColor"
                                  >
                                    <g>
                                      <g>
                                        <path
                                          d="M39,27.7c0,0-9.6-9.6-10.9-10.8c-1.4-1.2-3.6-1.2-5,0c-0.1,0.1-0.2,0.2-0.4,0.4c-1.1,1.3-0.9,3.1,0.4,4.2
                    l8.6,8.5l-8.6,8.5c-0.1,0.1-0.2,0.2-0.4,0.4c-1.1,1.3-0.9,3.1,0.4,4.2c1.4,1.2,3.6,1.2,5,0C29.4,41.9,39,32.3,39,32.3
                    c0.1-0.1,0.2-0.1,0.2-0.2C40.4,30.8,40.2,28.9,39,27.7z"
                                          fill="currentColor"
                                        ></path>
                                      </g>
                                    </g>
                                  </svg>
                                </i>
                              </a>
                            </div>
                          </div>
                          <div class="popbox buy-popbox">
                            <div class="button-buy-inner">
                              <div>
                                <div
                                  class="nt-button nt-button--default game-box-btn--store"
                                >
                                  <a class="button-wechat-store">
                                    微信官方商城
                                  </a>
                                </div>
                                <div class="qrcode-box">
                                  <picture>
                                    <source
                                      :srcset="buyLinkList.wx"
                                      type="image/png"
                                    />
                                    <img
                                      :src="buyLinkList.wx"
                                      alt=""
                                      class=""
                                    />
                                  </picture>
                                </div>
                                <div class="qrcode-scan">
                                  <p>打开微信扫一扫</p>
                                </div>
                              </div>
                              <div class="game-box-btn game-box-btn--top">
                                <div class="nt-button nt-button--default">
                                  <a :href="buyLinkList.jd" target="_blank">
                                    <i class="button-icon">
                                      <svg
                                        id="right-stroke-arrow"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="60"
                                        height="60"
                                        viewBox="0 0 60 60"
                                        aria-labelledby="right-stroke-arrow"
                                        role="presentation"
                                        fill="currentColor"
                                      >
                                        <g>
                                          <g>
                                            <path
                                              d="M39,27.7c0,0-9.6-9.6-10.9-10.8c-1.4-1.2-3.6-1.2-5,0c-0.1,0.1-0.2,0.2-0.4,0.4c-1.1,1.3-0.9,3.1,0.4,4.2
                    l8.6,8.5l-8.6,8.5c-0.1,0.1-0.2,0.2-0.4,0.4c-1.1,1.3-0.9,3.1,0.4,4.2c1.4,1.2,3.6,1.2,5,0C29.4,41.9,39,32.3,39,32.3
                    c0.1-0.1,0.2-0.1,0.2-0.2C40.4,30.8,40.2,28.9,39,27.7z"
                                              fill="currentColor"
                                            ></path>
                                          </g>
                                        </g>
                                      </svg>
                                    </i>
                                    京东官方旗舰店
                                  </a>
                                </div>
                              </div>
                              <div class="game-box-btn game-box-btn--bottom">
                                <div class="nt-button nt-button--default">
                                  <a :href="buyLinkList.tm" target="_blank">
                                    <i class="button-icon">
                                      <svg
                                        id="right-stroke-arrow"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="60"
                                        height="60"
                                        viewBox="0 0 60 60"
                                        aria-labelledby="right-stroke-arrow"
                                        role="presentation"
                                        fill="currentColor"
                                      >
                                        <g>
                                          <g>
                                            <path
                                              d="M39,27.7c0,0-9.6-9.6-10.9-10.8c-1.4-1.2-3.6-1.2-5,0c-0.1,0.1-0.2,0.2-0.4,0.4c-1.1,1.3-0.9,3.1,0.4,4.2
                    l8.6,8.5l-8.6,8.5c-0.1,0.1-0.2,0.2-0.4,0.4c-1.1,1.3-0.9,3.1,0.4,4.2c1.4,1.2,3.6,1.2,5,0C29.4,41.9,39,32.3,39,32.3
                    c0.1-0.1,0.2-0.1,0.2-0.2C40.4,30.8,40.2,28.9,39,27.7z"
                                              fill="currentColor"
                                            ></path>
                                          </g>
                                        </g>
                                      </svg>
                                    </i>
                                    天猫官方旗舰店
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- E 立即购买 -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="soft-sticky__footer"></div>
            </div>
          </div>
          <div id="section02" class="soft-products__section">
            <div class="ncommon-headline02">
              <div class="ncommon-headline02__body">软件使用人数・手柄</div>
            </div>
            <div class="soft-products__sectionInner">
              <div class="soft-products__spec">
                <div class="soft-products__specOuter">
                  <div class="soft-products__specInner">
                    <p class="soft-products__title">
                      拥有1台Nintendo Switch主机时的可游玩人数
                    </p>
                    <div class="soft-products__specTableOuter">
                      <table
                        class="soft-products__specTable soft-products__specTable--towHeader soft-products__specTable--columns"
                      >
                        <tr class="soft-products__specTableHeads">
                          <th>
                            <p class="soft-products__title">软件使用模式</p>
                          </th>
                          <th>
                            <div
                              class="soft-products__specIcon soft-products__specIcon--tv"
                            ></div>
                            <p class="soft-products__specShead">电视模式</p>
                          </th>
                          <th>
                            <div
                              class="soft-products__specIcon soft-products__specIcon--table"
                            ></div>
                            <p class="soft-products__specShead">桌面模式</p>
                          </th>
                          <th>
                            <div
                              class="soft-products__specIcon soft-products__specIcon--carry"
                            ></div>
                            <p class="soft-products__specShead">掌上模式</p>
                          </th>
                        </tr>
                        <tr class="soft-products__specTableBody">
                          <th>
                            <p class="soft-products__title">软件使用人数</p>
                          </th>
                          <td>
                            <p class="soft-products__title">
                              1人<sup class="soft-products__asterisk"></sup>
                            </p>
                          </td>
                          <td>
                            <p class="soft-products__title">
                              1人<sup class="soft-products__asterisk"></sup>
                            </p>
                          </td>
                          <td>
                            <p class="soft-products__title">
                              1人<sup class="soft-products__asterisk"></sup>
                            </p>
                          </td>
                        </tr>
                      </table>
                      <p class="soft-products__note">
                        可以制作多人游玩的游戏。
                      </p>
                    </div>
                  </div>
                  <div class="soft-products__specInner">
                    <p class="soft-products__title">支持手柄</p>
                    <div class="soft-products__specTableOuter">
                      <table
                        class="soft-products__specTable soft-products__specTable--controller soft-products__specTable--columns"
                      >
                        <tr class="soft-products__specTableHeads">
                          <th>
                            <div class="soft-products__specIconWrap">
                              <div
                                class="soft-products__specIcon soft-products__specIcon--joyConDouble"
                              >
                                <img
                                  src="../../assets/img/products/icn-spec__controller--joyConDouble.svg"
                                  alt=""
                                />
                              </div>
                              <p class="soft-products__specShead">
                                手持2个<br class="ncommon-u-hide-pc" />Joy-Con
                              </p>
                            </div>
                          </th>
                          <th>
                            <div class="soft-products__specIconWrap">
                              <div
                                class="soft-products__specIcon soft-products__specIcon--joyConGrip"
                              >
                                <img
                                  src="../../assets/img/products/icn-spec__controller--joyConGrip.svg"
                                  alt=""
                                />
                              </div>
                              <p class="soft-products__specShead">
                                Joy-Con<br class="ncommon-u-hide-pc" />握把
                              </p>
                            </div>
                          </th>
                        </tr>
                        <tr class="soft-products__specTableBody">
                          <td>
                            <div class="soft-products__specSupport">
                              <img
                                src="../../assets/img/products/icn-spec__active--gray.svg"
                                alt=""
                              />
                              <p class="soft-products__title">支持</p>
                            </div>
                          </td>
                          <td>
                            <div class="soft-products__specSupport">
                              <img
                                src="../../assets/img/products/icn-spec__active--gray.svg"
                                alt=""
                              />
                              <p class="soft-products__title">支持</p>
                            </div>
                          </td>
                        </tr>
                      </table>
                      <table
                        class="soft-products__specTable soft-products__specTable--controller soft-products__specTable--columns"
                      >
                        <tr class="soft-products__specTableHeads">
                          <th>
                            <div class="soft-products__specIconWrap">
                              <div
                                class="soft-products__specIcon soft-products__specIcon--joyConHorizontal"
                              >
                                <img
                                  src="../../assets/img/products/icn-spec__controller--joyConHorizontal.svg"
                                  alt=""
                                />
                              </div>
                              <p class="soft-products__specShead">
                                横握<br
                                  class="ncommon-u-hide-pc ncommon-u-hide-tab"
                                />Joy-Con<br class="ncommon-u-hide-sp" />
                              </p>
                            </div>
                          </th>
                          <th>
                            <div class="soft-products__specIconWrap">
                              <div
                                class="soft-products__specIcon soft-products__specIcon--pro"
                              >
                                <img
                                  src="../../assets/img/products/icn-spec__controller--pro.svg"
                                  alt=""
                                />
                              </div>
                              <p class="soft-products__specShead">
                                Nintendo Switch<br />专业手柄<br />（另售）
                              </p>
                            </div>
                          </th>
                        </tr>
                        <tr class="soft-products__specTableBody">
                          <td>
                            <div
                              class="soft-products__specSupport soft-products__specSupport--disable"
                            >
                              <img
                                src="../../assets/img/products/icn-spec__disable--lightGray.svg"
                                alt=""
                              />
                              <p class="soft-products__title">不支持</p>
                            </div>
                          </td>
                          <td>
                            <div class="soft-products__specSupport">
                              <img
                                src="../../assets/img/products/icn-spec__active--gray.svg"
                                alt=""
                              />
                              <p class="soft-products__title">支持</p>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <p class="soft-products__note">
                    在电视模式下支持使用USB接口鼠标
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- page end -->

      <!-- ===== footer start ===== -->
      <div class="soft-products__footer scroll-end">
        <a
          href="/awuxa/"
          class="ncommon-bt soft-products__button"
          data-style="transparent"
          style="color: #d9d9d9;"
          ><i class="ncommon-icon rightSvg" data-style="fill" data-reverse="1"
            ><i><i></i></i></i
          ><span>回到主页 </span></a
        >
      </div>
      <!-- ===== footer end ===== -->
    </div>
    <!-- /outer -->
  </div>
</template>

<script>
import '../../assets/css/buy-now.css';
import '../../assets/css/products.css';
import '../../assets/css/local.css';
import { buyLinkList } from '../api';
export default {
  data() {
    return {
      activeSection: '#section01',
      scroll: false,
      isMobile: false,
      buyLinkList
    };
  },
  computed: {
    scrollClass() {
      return this.scroll ? 'js-fixed' : 'js-static';
    }
  },
  created() {
    if ('scrollRestoration' in window.history) {
      // chrom 记住滚动条的回弹bug
      window.history.scrollRestoration = 'manual';
    }
    document.body.setAttribute('data-softid', 'awuxa');
    document.body.setAttribute('data-theme', 'switch');
    document.body.style.backgroundColor = '#ffffff';
    document.body.style.backgroundPosition = 'center bottom';
    this.setWindowWidth();
    window.onresize = () => {
      this.setWindowWidth();
    };
  },
  mounted() {
    if (location.hash.indexOf('#section') === 0) {
      this.toSection(location.hash);
    }
    this.checkScroll();
    document.addEventListener('scroll', this.checkScroll);
  },
  methods: {
    checkScroll() {
      const scrollTop = document.scrollingElement
        ? document.scrollingElement.scrollTop
        : 0;
      const start = document.getElementsByClassName('scroll-start');
      const end = document.getElementsByClassName('scroll-end');
      const node = document.getElementsByClassName('scroll-target');
      if (start[0] && end[0] && node[0]) {
        const { top } = start[0].getBoundingClientRect();
        const endRect = end[0].getBoundingClientRect();
        const nodeHeight = node[0].getBoundingClientRect().height;
        const bottom = endRect.top - nodeHeight;
        this.scroll =
          scrollTop > top + scrollTop && scrollTop < bottom + scrollTop;
      } else {
        this.scroll = scrollTop > 500;
      }
      const section02 = document.getElementById('section02');
      if (section02) {
        // 滚到他下边要切换tab active
        const sRect = section02.getBoundingClientRect();
        this.activeSection = sRect.y - 10 < 0 ? '#section02' : '#section01';
      }
    },
    toSection(id) {
      const section = document.getElementById(id.replace('#', ''));
      if (section) {
        this.activeSection = id;
        section.scrollIntoView({ behavior: 'smooth' });
      }
    },
    setWindowWidth() {
      const windowWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      this.isMobile = windowWidth <= 760;
    }
  }
};
</script>

<style>
body {
  line-height: 1 !important;
}
.soft-products__button--buy.offdevice--buy .soft-products__icon:before {
  background-color: orange;
}
.ncommon-bt.offdevice--buy {
  color: orange;
}
.thumbPic {
  background-image: url(../../assets/img/soft/img-soft__thumb--pc.jpg);
}
.rightSvg {
  background-image: url(../../assets/img/icn__right.svg);
}

@media screen and (min-width: 760px) {
  .soft-products__specSupport img {
    width: auto;
  }
}
</style>
